import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { filterByFeatured } from '../features/filter/filterSlice'

export default function FilterAction() {
    const dispatch = useDispatch()
    const { featured } = useSelector(state => state.filter)

    function filterBookByFeatured(value) {
        dispatch(filterByFeatured(value))
    }

    return (
        <div class="flex items-center justify-between mb-12">
            <h4 class="mt-2 text-xl font-bold">Book List</h4>
            <div class="flex items-center space-x-4">
                <button onClick={() => filterBookByFeatured(false)} class={`lws-filter-btn ${!featured ? "active-filter" : ""}`}>All</button>
                <button onClick={() => filterBookByFeatured(true)} class={`lws-filter-btn ${featured ? "active-filter" : ""}`}>Featured</button>
            </div>
        </div>
    )
}
